var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HeaderNavLink',{staticClass:"grid-component-button text-white font-semibold flex justify-center items-center bg-primary focus:ring",class:`style-${_vm.component.style}`,attrs:{"url":_vm.component.url}},[_vm._t("icon"),_vm._v(" "),_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.component.label))]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }